<template>
  <div>
    <button @click="showFileRecord = !showFileRecord" v-if="!showFileRecord"
            class="btn btn-outline-info btn-xs"><i class="icon-fa icon-fa-volume-up"/> Прослушать запись
    </button>
    <template v-if="showFileRecord">
      <audio controls v-if="record">
        <source
          :src="`https://admin.rancond.info/api/noa/mangoRecord/${record.id}`"
          type="audio/mpeg"
        />
        Your browser does not support the audio tag.
      </audio>
    </template>
  </div>
</template>
<script>
export default {
  props: ['record'],
  data() {
    return {
      showFileRecord: false,
    }
  }
}
</script>

<style scoped>
audio {
  height: 37px;
}

</style>
